import { Injectable } from '@angular/core';
import cssVars from 'css-vars-ponyfill';
import { darkTheme, lightTheme } from '../../../assets/styles/Themes';
import { ITheme } from '../interfaces/ITheme';

@Injectable({
    providedIn: 'root'
})
export class ThemeService {
    public setTheme(mode: 'light' | 'dark'): void {
        const htmlElement = document.documentElement;
        if (mode === 'dark') {
            htmlElement.classList.add('dark');
            htmlElement.setAttribute('data-mode', 'dark');
        } else {
            htmlElement.classList.remove('dark');
            htmlElement.removeAttribute('data-mode');
        }
        const variables = this.getThemeVariables(mode);
        this.setColorVariables(variables);
    }

    private getThemeVariables(mode: 'light' | 'dark'): ITheme {
        if (mode === 'dark') {
            return darkTheme;
        } else {
            return lightTheme;
        }
    }

    private setColorVariables(colorPalette: ITheme): void {
        cssVars({
            variables: {
                ...colorPalette
            }
        });
    }
}
